import { useSelector } from "react-redux";
import { selectUserData } from "../config/redux/slices/userSlice/selectors";

const useCronKeyCheck = () => {
  const user = useSelector(selectUserData);
  const { config } = user.data;
  return config?.isCronJobKeySetup;
};

export default useCronKeyCheck;;
